// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2qpCz","search":"Settings_search__166Fm","filter":"Settings_filter__1d_kI"};